import React from 'react';
import { PropTypes } from 'prop-types';
import { Pie } from 'react-chartjs-2';

const LOANPIE = (props) => {
    const {
        annualResults,
        selectedFinancing,
        doughnutSlider,
        projectState,
        sgipToggle,
        loanProvider,
        resiToggle,
    } = props;

    const doughYears = doughnutSlider;

    const annualUtilityPayment =
        annualResults[doughYears].formattedAnnualBill -
            annualResults[doughYears].annualSolarSavings >
        0
            ? annualResults[doughYears].formattedAnnualBill -
              annualResults[doughYears].annualSolarSavings
            : 0;

    let loan = 0;
    if (loanProvider === 'mosaic' && resiToggle) {
        loan = annualResults[doughYears].annualHomeLoanPayment;
    } else {
        loan = annualResults[doughYears].loanPayment;
    }


    const loanVsUtilityCostPolar = {
        datasets: [
            {
                data: [
                    annualUtilityPayment,
                    annualResults[doughYears].annualSolarSavings,
                    loan,
                    annualResults[doughYears].itc,
                    annualResults[doughYears].macrs,
                ],
                backgroundColor: ['#db4141', '#61ff9a', '#01B5D2', '#dfff61', '#ffe761'],
            },
        ],
        labels: ['Remaining Utility ($)', 'Solar Value ($)', 'Loan ($) ', 'ITC ($)', 'MACRS ($)'],
    };

    const loanVsUtilityCostPolarRECS = {
        datasets: [
            {
                data: [
                    annualUtilityPayment,
                    loan,
                    annualResults[doughYears].annualSolarSavings,
                    annualResults[doughYears].itc,
                    annualResults[doughYears].macrs,
                    annualResults[doughYears].recs,
                ],
                backgroundColor: ['#db4141', '#61e9ff', '#61ff9a', '#dfff61', '#ffe761', '#FFAC33'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'Loan ($) ',
            'Solar Value ($)',
            'ITC ($)',
            'MACRS ($)',
            'RECs ($)',
        ],
    };

    const loanVsUtilityCostPolarSGIP = {
        datasets: [
            {
                data: [
                    annualUtilityPayment,
                    loan,
                    annualResults[doughYears].annualSolarSavings,
                    annualResults[doughYears].itc,
                    annualResults[doughYears].macrs,
                    annualResults[doughYears].sgip,
                    annualResults[doughYears].sgipPBI,
                ],
                backgroundColor: ['#db4141', '#61e9ff', '#61ff9a', '#dfff61', '#ffe761', '#FFAC33', '#42f4c8', '#8641f4'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'Loan ($) ',
            'Solar Value ($)',
            'ITC ($)',
            'MACRS ($)',
            'SGIP ($)',
            'SGIP PBI',
        ],
    };

    const loanVsUtilityCostPolarSMART = {
        datasets: [
            {
                data: [
                    annualUtilityPayment,
                    loan,
                    annualResults[doughYears].annualSolarSavings,
                    annualResults[doughYears].itc,
                    annualResults[doughYears].macrs,
                    annualResults[doughYears].smart,
                    annualResults[doughYears].maStateTaxCredit,
                ],
                backgroundColor: ['#db4141', '#61e9ff', '#61ff9a', '#dfff61', '#ffe761', '#42f4c8', '#7abfff'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'Loan ($) ',
            'Solar Value ($)',
            'ITC ($)',
            'MACRS ($)',
            'SMART ($)',
            'MA Tax Credit',
        ],
    };

    const loanVsUtilityCostPolarNYResi = {
        datasets: [
            {
                data: [
                    annualUtilityPayment,
                    loan,
                    annualResults[doughYears].annualSolarSavings,
                    annualResults[doughYears].itc,
                    annualResults[doughYears].nyserdaRebate,
                    annualResults[doughYears].mosaicNYAbatement,
                    annualResults[doughYears].nyResiTaxCredit,

                ],
                backgroundColor: ['#db4141', '#61e9ff', '#dfff61', '#ffe761', '#42f4c8', '#8334eb', '#eb34cc', '#eb4934'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'Loan ($) ',
            'Solar Value ($)',
            'ITC ($)',
            'NYSERDA Rebate',
            'Property Abatement',
            'NY Tax Credit',
        ],
    };
    const loanVsUtilityCostPolarNYCommercial = {
        datasets: [
            {
                data: [
                    annualUtilityPayment,
                    loan,
                    annualResults[doughYears].annualSolarSavings,
                    annualResults[doughYears].itc,
                    annualResults[doughYears].macrs,
                    annualResults[doughYears].nyserdaRebate,
                    annualResults[doughYears].cashNYAbatement,
                ],
                backgroundColor: ['#db4141', '#61e9ff', '#61ff9a', '#dfff61', '#ffe761', '#42f4c8', '#8334eb', '#eb34cc', '#eb4934'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'Loan ($) ',
            'Solar Value ($)',
            'ITC ($)',
            'MACRS ($)',
            'NYSERDA Rebate',
            'Property Abatement',
        ],
    };

    let data = null;
    if (projectState === 3 && selectedFinancing === 2) {
        data = loanVsUtilityCostPolarRECS;
    } else if (projectState === 1 && selectedFinancing === 2 && sgipToggle === true) {
        data = loanVsUtilityCostPolarSGIP;
    } else if (projectState === 2 && selectedFinancing === 2) {
        data = loanVsUtilityCostPolarSMART;
    } else if (projectState === 4 && selectedFinancing === 2 && resiToggle) {
        data = loanVsUtilityCostPolarNYResi;
    } else if (projectState === 4 && selectedFinancing === 2 && resiToggle === false) {
        data = loanVsUtilityCostPolarNYCommercial;
    } else {
        data = loanVsUtilityCostPolar;
    }

    return (
        <div>
            {selectedFinancing === 2 ? (
                <li>
                    <Pie
                        height={345}
                        data={data}
                        options={{ maintainAspectRatio: true }}
                    />
                </li>
            ) : null}
        </div>
    );
};

LOANPIE.propTypes = {
    annualResults: PropTypes.object.isRequired,
    selectedFinancing: PropTypes.number.isRequired,
    doughnutSlider: PropTypes.number.isRequired,
    projectState: PropTypes.number.isRequired,
    sgipToggle: PropTypes.bool.isRequired,
    loanProvider: PropTypes.string.isRequired,
    resiToggle: PropTypes.bool.isRequired,
};

export default LOANPIE;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/Graphs/LOANPIE/LOANPIE.js